import { useState, useEffect } from "react";
import style from "./GoToTop.module.scss";
import { HiOutlinePaperAirplane } from "react-icons/hi";

export const GoToTop = () => {
  const [isGoToVisible, setIsGoToVisible] = useState(false);

  const handleScroll = () => {
    const { pageYOffset } = window;
    if (pageYOffset > 500) {
      setIsGoToVisible(true);
    } else if (pageYOffset < 499) {
      setIsGoToVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const { goToBox, goToBox__hidden } = style;

  return (
    <section>
      <button className={isGoToVisible ? goToBox : goToBox__hidden}
          onClick={() => {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }}
        >
          <HiOutlinePaperAirplane />
        </button>
    </section>
    
  );
};
